import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ProjectProtocol } from '../../../dtos/project-protocol';
import { InfoIconComponent } from '../project-guide/info-icon/info-icon.component';

@Component({
  selector: 'app-protocol-card',
  standalone: true,
  imports: [CommonModule, FormsModule, InfoIconComponent],
  templateUrl: './protocol-card.component.html',
  host: { style: 'display: block;' },
})
export class ProtocolCardComponent implements OnChanges {
  @Input({ required: true }) protocol: ProjectProtocol | null = null;
  @Input() isEditable = false;
  @Input() isLocked = false;
  @Input() saving = false;
  @Input() collapsed = false;

  @Output() save = new EventEmitter<ProjectProtocol>();
  @Output() editChange = new EventEmitter<boolean>();
  @Output() collapsedChange = new EventEmitter<boolean>();

  isEditing = false;
  editResearchQuestions = '';
  editSearchMethodology = '';
  editCohenKappaThreshold = 0.8;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['protocol'] && !changes['protocol'].firstChange && this.isEditing) {
      this.isEditing = false;
      this.editChange.emit(false);
    }
  }

  startEditing(): void {
    this.editResearchQuestions = this.protocol?.researchQuestions || '';
    this.editSearchMethodology = this.protocol?.searchMethodology || '';
    this.editCohenKappaThreshold = this.protocol?.cohenKappaThreshold ?? 0.8;
    this.isEditing = true;
    this.editChange.emit(true);
  }

  cancelEditing(): void {
    this.isEditing = false;
    this.editChange.emit(false);
  }

  onSubmit(): void {
    if (this.saving) return;
    this.save.emit({
      researchQuestions: this.editResearchQuestions,
      searchMethodology: this.editSearchMethodology,
      cohenKappaThreshold: this.editCohenKappaThreshold,
    });
  }
}
